/* eslint-disable @typescript-eslint/typedef */

export const Lekkerland2026CmsBackgroundColors = [
  'blue',
  'green',
  'purple',
  'yellow',
  'orange',
  'turquoise',
] as const;

export type Lekkerland2026CmsBackgroundColor = typeof Lekkerland2026CmsBackgroundColors[number];
